.fullWidth {
  width: 100%;
}

.gutters {
  padding: 8px 16px;
}
